<template>
  <div>
    <b-card title="Bienvenue sur le dashboard Senseye 🚀">
      <b-card-text>Vous pouvez ici gérer vos lunettes et vos commandes.</b-card-text>
     
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
}
</script>

<style>

</style>
